import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { Router } from '@angular/router';

import { RiskEvalutionExecutionService } from '../../../../services/risk-evalution-execution.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { RiskConfirmationPopupComponent } from '../../risk-confirmation-popup/risk-confirmation-popup.component';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-risk-view-overall-questions',
  templateUrl: './risk-view-overall-questions.component.html',
  styleUrls: ['./risk-view-overall-questions.component.css']
})
export class RiskViewOverallQuestionsComponent implements OnInit {
  @Input('deptName') deptName: any;
  @Input('criteriaList') criteriaList: any;
  @Input('question') question: any;
  @Input('criteriaName') criteriaName: any;
  @Input('scoreRange') scoreRange: any;
  @Input('scoreParticularDetails') scoreParticularDetails: any;
  @Input('answerDetails') answerDetails: any;
  @Input('assignedFormId') assignedFormId: any;
  @Input('formAnonymous') formAnonymous: any;
  @Input('IsFormEvaluated') IsFormEvaluated: any;
  @Input('isNextButtonEnabled') isNextButtonEnabled: any;
  @Input('comments') comments: any;
  @Input('assesseeListToExecute') assesseeListToExecute: any;
  @Output() changedStatus = new EventEmitter();
  @Output() commentChangeStatus = new EventEmitter();

  scoreRangeObject: any = [];
  public emitObject: any;
  public submitBtnStatus: boolean = false;
  public answerStatus: any;
  public hidePreviousButton: boolean;
  public hideNextButton: boolean;
  public viewsubmitQuestionBtnStatus: boolean = false;
  totalQuestion: any = 0;
  answerComments: any;
  answerScore: any = [];
  answeredCount: any = 0;
  showSpinner: boolean = false;
  commentEnable: any;
  overallComments: any;
  subscribe: Subscription;
  answerListAsPerAssesseeList: any = [];
  enableNextButton: Boolean = false;

  constructor(
    public riskEvaluationExecutionService: RiskEvalutionExecutionService,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.submitBtnStatus = false;
    this.answerStatus = 'Not Answrered';
    this.hidePreviousButton = false;
    this.hideNextButton = false;
    this.emitObject = {
      status: '',
      buttonClick: '',
      questionid: '',
      response: '',
      criteriaId: '',
      deptId: ''
    };

    console.log('contrcutor');
    this.overallComments = {
      Comments: '',
      evaluationFormId: '',
      assesseeId: '',
    };
  }

  impactPercent: string;
  probabilityOptions: any[] = [];
  selectedProbability: string; // To hold the selected _id




  ngOnInit() {
    this.initialiseSubjectSubscription();

    this.getRiskProbabilityList();
    // Then call:
    this.bindAnswersToValue();
    // console.log("assesseeListToExecute", this.assesseeListToExecute , this.criteriaName, this.formAnonymous)
  }



  validateAndFormatPercent() {
    if (!this.impactPercent) return;

    // Remove all spaces
    this.impactPercent = this.impactPercent.trim();

    // Remove % if present temporarily
    const hasPercent = this.impactPercent.endsWith('');
    let valueStr = hasPercent ? this.impactPercent.slice(0, -1) : this.impactPercent;

    // Validate numeric range 1 to 100
    let value = parseFloat(valueStr);
    if (isNaN(value) || value < 1) {
      value = 1;
    } else if (value > 100) {
      value = 100;
    }

    // Set formatted string with % if user input included it
    this.impactPercent = hasPercent ? `${value}%` : `${value}`;
  }


  getRiskProbabilityList() {
    this.riskEvaluationExecutionService.getRiskProbabilityList()  // Use the correct injected service
      .then(response => {
        if (response.status === 0) {
          if (response.data && response.data.length > 0) {
            this.probabilityOptions = response.data;
            this.probabilityOptions = response.data.map(item => ({
              id: item._id,
              label: item.ProbabilityValue,
              value: item.ProbabilityValue
            }));
            // Set the options from API
          } else {
            // If no data, initialize the master once
            this.initializeRiskProbabilityMaster();
          }
        }
      })
      .catch(error => {
        console.error('Error fetching probability list:', error);
      });
  }

  initializeRiskProbabilityMaster() {
    this.riskEvaluationExecutionService.initializeRiskProbabilityMaster()
      .then(response => {
        if (response.status === 0 && response.data && response.data.length > 0) {
          this.probabilityOptions = response.data;  // Set initialized data
          this.probabilityOptions = response.data.map(item => ({
            id: item._id,
            label: item.ProbabilityValue,
            value: item.ProbabilityValue
          }));

          // No need to call getRiskProbabilityList again to avoid infinite loop
        }
      })
      .catch(error => {
        console.error('Error initializing probability master:', error);
      });
  }




  returnAnswerStructure(
    questionId,
    answerScore,
    criteriaId,
    assesseeId,
    assesseeName,
    evaluationFormId,
    answeredStatus,
    IsFormEvaluated,
    IsAnonymous,
    Comments
  ) {
    return {
      questionId: questionId,
      AnswerScore: answerScore,
      CriteriaId: criteriaId,
      assesseeId: assesseeId,
      assesseeName: assesseeName,
      evaluationFormId: evaluationFormId,
      answeredStatus: answeredStatus,
      IsFormEvaluated: IsFormEvaluated,
      IsAnonymous: IsAnonymous,
      Comments: Comments,
    };
  }

  async initialiseSubjectSubscription() {
    this.subscribe =
      await this.riskEvaluationExecutionService.commentsObservable.subscribe((res) => {
        this.commentEnable = res;
      });
  }

  ngOnChanges(event) {
    var self = this;
    var index1;
    this.scoreRange = this.scoreRange;
    this.scoreParticularDetails = this.scoreParticularDetails;

    if (
      this.assesseeListToExecute &&
      this.question &&
      this.criteriaName &&
      this.assesseeListToExecute.length > 0 &&
      this.question._id &&
      this.criteriaName._id
    ) {
      this.bindAnswersToValue();
    }


    //console.log("scoreParticularDetails=================+", this.scoreParticularDetails)
    var i = 0;
    for (i; i < this.scoreRange; i++) {
      this.scoreRangeObject.push({ label: i + 1, value: i + 1, index: i });
    }
    _.forEach(self.scoreParticularDetails, function (selecteddata) {
      index1 = _.findIndex(self.scoreRangeObject, function (object) {
        return _.get(object, 'index') == _.get(selecteddata, 'index');
      });
      self.scoreRangeObject[index1].data = selecteddata.scoreValue;
    });
    this.scoreRangeObject = _.uniqBy(this.scoreRangeObject, 'value');

    this.bindAnswersToValue();
    this.checkAllQuestionsAnswered();

    this.enableSubmitButton();

    // console.log("event",event)

    if (
      !_.isUndefined(event.assesseeListToExecute) &&
      !_.isUndefined(event.assesseeListToExecute.currentValue)
    ) {
      if (Array.isArray(event.assesseeListToExecute.currentValue)) {
        // console.log("this.overallComments",this.overallComments)
        if (
          !_.isUndefined(this.overallComments.evaluationFormId) &&
          this.overallComments.evaluationFormId != ''
        ) {
          var found = event.assesseeListToExecute.currentValue.findIndex(
            (element) => {
              return element.AssesseeId == this.overallComments.assesseeId;
            }
          );
          // console.log("found",found)

          if (found >= 0) {
            var commentRadio: any = document.getElementsByName('comments');
            //  console.log("commentRadio",commentRadio)
            setTimeout(() => {
              commentRadio.forEach((element: HTMLInputElement) => {
                if (element.value == this.overallComments.assesseeId) {
                  //  console.log("element - checked",true)
                  element.checked = true;
                }
              });
            }, 0);
          }
        } else {
          // var firstElement = event.assesseeListToExecute.currentValue[0]
          // // console.log("firstElement",firstElement)
          // this.overallComments.assesseeId = firstElement.AssesseeId
          // this.overallComments.evaluationFormId  = firstElement._id,
          // this.overallComments.Comments = firstElement.Comments
          // setTimeout(() => {
          //   var commentRadio : any =  document.getElementsByName("comments")
          //   // console.log("commentRadio",commentRadio)
          //   commentRadio.forEach((element : HTMLInputElement) => {
          //     if(element.value == this.overallComments.assesseeId){
          //     //  console.log("element - checked",true)
          //       element.checked = true;
          //     }
          //   })
          //  }, 200);
        }
      }
    }
  }

  changedAnswerScore(assessee: any) {
    const probabilityFilled = !!assessee.selectedProbability;
    const impactFilled = !!assessee.impactPercent && assessee.impactPercent.trim() !== '';

    assessee.answeredStatus = (probabilityFilled && impactFilled) ? 'Answered' : null;

    // Sync answerListAsPerAssesseeList with latest UI state
    this.buildAnswerListForSubmission();

    this.checkAllQuestionsAnswered();
    this.enableSubmitButton();
  }

  assesseeAnswerBind(assessee) {
    // console.log("assessee",assessee)
  }

  bindValueToControl(assessee, question, subcount) {
    // console.log("assessee , question ,subcount",assessee , question ,subcount)
  }

  ngOnDestroy() {
    this.riskEvaluationExecutionService.commentsEvent$.next(false);
    this.subscribe.unsubscribe();
  }


  bindAnswersToValue() {
    console.log('assesseeListToExecute:', this.assesseeListToExecute);
    console.log('Current question._id:', this.question?._id);
    console.log('Current criteriaName._id:', this.criteriaName?._id);

    this.answerListAsPerAssesseeList = [];

    if (!_.isUndefined(this.assesseeListToExecute)) {
      this.assesseeListToExecute.forEach((element) => {
        console.log('Processing assessee:', element.assesseeId);

        let selectedProbability = '';
        let impactPercent = '';
        let answeredStatus = null;

        if (_.size(element.Answers) > 0) {
          // Find the answer for this question and criteria id exactly
          const found = _.findIndex(element.Answers, (answerElement) => {
            const ans = answerElement as { QuestionId: string; EvaluationCriteriaId: string };
            console.log('Checking answer:', ans.QuestionId, ans.EvaluationCriteriaId);
            return ans.QuestionId === this.question._id && ans.EvaluationCriteriaId === this.criteriaName._id;
          });

          console.log('Found answer at index:', found);

          if (found < 0) {
            // No answer found, initialize defaults on element
            element.selectedProbability = '';
            element.impactPercent = '';
            element.answeredStatus = null;

            this.answerListAsPerAssesseeList.push(
              this.returnAnswerStructure(
                this.question._id,
                0,
                this.criteriaName._id,
                element.assesseeId,
                element.newAssesseDetails,
                element._id,
                null,
                element.IsFormEvaluated,
                element.IsAnonymous,
                element.Comments || ''
              )
            );
          } else {
            const answerObj = element.Answers[found];
            console.log('AnswerObj found:', answerObj);

            if (Array.isArray(answerObj.AnswerScore)) {
              const probObj = answerObj.AnswerScore.find((as: any) => as.Probability !== undefined);
              const impactObj = answerObj.AnswerScore.find((as: any) => as.Impact !== undefined);

              selectedProbability = probObj ? probObj.Probability : '';
              impactPercent = impactObj ? impactObj.Impact : '';
            }

            answeredStatus = answerObj.AnswerStatus || null;
            console.log("probab", selectedProbability);
            // Patch values on element (for template two-way binding)
            element.selectedProbability = selectedProbability;
            element.impactPercent = impactPercent;
            element.answeredStatus = answeredStatus;

            // Instead of mutating existing element, create new object copy with updated props
            const updatedElement = {
              ...element,
              selectedProbability,
              impactPercent,
              answeredStatus
            };
            // replace element in array with updated one:
            const index = this.assesseeListToExecute.indexOf(element);
            if (index !== -1) {
              this.assesseeListToExecute[index] = updatedElement;
            }


            // Build answer score array for structured answer
            const answerScore = [
              { Probability: selectedProbability || '' },
              { Impact: impactPercent || '' }
            ];

            this.answerListAsPerAssesseeList.push(
              this.returnAnswerStructure(
                this.question._id,
                answerScore,
                this.criteriaName._id,
                element.assesseeId,
                element.newAssesseDetails,
                element._id,
                answeredStatus,
                element.IsFormEvaluated,
                element.IsAnonymous,
                element.Comments || ''
              )
            );
          }
        } else {
          // No Answers present, initialize default values on element
          element.selectedProbability = '';
          element.impactPercent = '';
          element.answeredStatus = null;

          this.answerListAsPerAssesseeList.push(
            this.returnAnswerStructure(
              this.question._id,
              0,
              this.criteriaName._id,
              element.assesseeId,
              element.newAssesseDetails,
              element._id,
              null,
              element.IsFormEvaluated,
              element.IsAnonymous,
              element.Comments || ''
            )
          );
        }
      });
    }
  }


  confirmSubmitEvaluationExecution() {
    $('#submitEvaluationModal').modal('toggle');
  }

  navigateToSubmittedQuestion() { }

  next(event) {
    this.buildAnswerListForSubmission();
    this.riskEvaluationExecutionService
      .answerOverallEvaluationFormExecution(this.answerListAsPerAssesseeList)
      .then((res) => {
        this.emitObject.questionid = this.question._id;
        this.emitObject.criteriaId = this.criteriaName._id;
        this.emitObject.response = res;
        this.emitObject.status = 'Answered';
        this.emitObject.buttonClick = 'next';
        this.emitObject.deptId = this.deptName._id;

        this.changedStatus.emit(this.emitObject);

        this.showSpinner = false;

        this.enableSubmitButton();
        if (this.submitBtnStatus) {
          const modalRef = this.modalService.open(RiskConfirmationPopupComponent, {
            backdrop: 'static',
          });
          modalRef.componentInstance.Message = 'You can now Submit Evaluation';
          modalRef.result.then(
            (resp) => { },
            (error) => { }
          );
        }
      });
  }

  checkAllQuestionsAnswered() {
    var found = _.findIndex(this.answerListAsPerAssesseeList, (element) => {
      return _.get(element, 'answeredStatus') != 'Answered';
    });

    if (found >= 0) {
      this.enableNextButton = false;
    } else {
      this.enableNextButton = true;
    }

    if (this.enableNextButton) {
      var foundElement = _.findIndex(
        this.answerListAsPerAssesseeList,
        (element) => {
          return _.get(element, 'IsFormEvaluated') != true;
        }
      );
      if (foundElement >= 0) {
        this.enableNextButton = true;
      } else {
        this.enableNextButton = false;
        this.IsFormEvaluated = true;
      }
    }
  }

  enableSubmitButton() {
    if (!_.isUndefined(this.assesseeListToExecute)) {
      var totalAssessee = _.size(this.assesseeListToExecute);
      var totalNumberOfQuestions = 0;
      var element = this.assesseeListToExecute[0];

      element.EvaluationFormId.EvaluationCriterias.forEach(
        (criteriaElement) => {
          // console.log("criteriaElement",criteriaElement)
          totalNumberOfQuestions =
            totalNumberOfQuestions + _.size(criteriaElement.EvaluationQuestion);
        }
      );

      totalNumberOfQuestions = totalNumberOfQuestions * totalAssessee;

      var totalAnsweredQuestions = 0;

      this.assesseeListToExecute.forEach((element) => {
        totalAnsweredQuestions =
          totalAnsweredQuestions + _.size(element.Answers);
      });

      if (totalNumberOfQuestions == totalAnsweredQuestions) {
        this.submitBtnStatus = true;
        this.assesseeListToExecute.forEach((element) => {
          element.Answers.forEach((answerElement) => {
            if (answerElement.AnswerStatus != 'Answered') {
              this.submitBtnStatus = false;
            }
          });
        });
      } else {
        this.submitBtnStatus = false;
      }
    }

    // console.log("totalNumberOfQuestions",totalNumberOfQuestions, this.assesseeListToExecute, totalAnsweredQuestions, this.submitBtnStatus)
  }

  submitEvaluationExecution() {
    // console.log("answerListAsPerAssesseeList", this.answerListAsPerAssesseeList)

    this.showSpinner = true;
    $('#submitEvaluationModal').modal('toggle');
    var userInfo = JSON.parse(localStorage.getItem('user'));

    var objectArray = [];

    this.answerListAsPerAssesseeList.forEach((element) => {
      objectArray.push({
        "formId": element.evaluationFormId,
        "IsAnonymous": element.IsAnonymous,
        "AssigneeId": userInfo._id
      })
    })


    this.riskEvaluationExecutionService.submitOverAllEvaluationExecutionForm(objectArray).then(res => {
      // console.log("res",res)
      this.showSpinner = false;
      $('#alertTitle').text("Success!");
      $('#alertTitle').css("color", "black");
      $('#alertMessage').text(res.message);
      $('#alertMessage').css("color", "black");
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
      this.router.navigate(['structure', { outlets: { 'structure-outlet': ['riskIndividualReportList'] } }]);
    })

  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  closeForm(id) {
    $('#' + id).modal('toggle');
    this.ngOnInit();
  }

  changeUserForComments(event, assessee) {
    this.overallComments = {
      Comments: assessee.Comments,
      evaluationFormId: assessee.evaluationFormId,
      assesseeId: assessee.assesseeId,
    };
  }

  submitComments() {
    var commentsObject = {
      _id: this.overallComments.evaluationFormId,
      Comments: this.overallComments.Comments,
    };
    this.showSpinner = true;
    if (
      _.isUndefined(this.overallComments.evaluationFormId) ||
      this.overallComments.evaluationFormId == ''
    ) {
      this.showSpinner = false;
      return;
    }

    this.riskEvaluationExecutionService.submitComments(commentsObject).then((res) => {
      var objectToSend = [];
      this.answerListAsPerAssesseeList.forEach((element) => {
        objectToSend.push({
          assesseeId: element.assesseeId,
          executionFormId: element.evaluationFormId,
        });
      });
      this.riskEvaluationExecutionService
        .getAssignedEvalutionFormDetailsByArrayOfId(objectToSend)
        .then((res) => {
          this.showSpinner = false;
          this.commentChangeStatus.emit(res);

        });
    });
  }

  buildAnswerListForSubmission() {
    this.answerListAsPerAssesseeList = this.assesseeListToExecute.map(element => {
      // Use the latest values from the UI
      const answerScore = [
        { Probability: element.selectedProbability || '' },
        { Impact: element.impactPercent || '' }
      ];
      return {
        questionId: this.question._id,
        AnswerScore: answerScore,
        CriteriaId: this.criteriaName._id,
        assesseeId: element.assesseeId,
        assesseeName: element.assesseeName || element.newAssesseDetails,
        evaluationFormId: element._id,
        answeredStatus: element.answeredStatus,
        IsFormEvaluated: element.IsFormEvaluated,
        Comments: element.Comments || '',
        // Include these for backend compatibility
        selectedProbability: element.selectedProbability || '',
        impactPercent: element.impactPercent || ''
      };
    });
  }
}

